var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.46667V0.866667C4 0.636812 4.10536 0.416372 4.29289 0.253841C4.48043 0.0913092 4.73478 0 5 0H17C17.2652 0 17.5196 0.0913092 17.7071 0.253841C17.8946 0.416372 18 0.636812 18 0.866667V13C18 13.2299 17.8946 13.4503 17.7071 13.6128C17.5196 13.7754 17.2652 13.8667 17 13.8667H14V16.4667C14 16.9451 13.55 17.3333 12.993 17.3333H1.007C0.875127 17.334 0.744397 17.3121 0.622322 17.2689C0.500247 17.2256 0.389233 17.1619 0.295659 17.0814C0.202084 17.0009 0.127793 16.9051 0.0770543 16.7996C0.0263156 16.6941 0.000129374 16.581 0 16.4667L0.00300002 4.33333C0.00300002 3.85493 0.453 3.46667 1.01 3.46667H4ZM2.003 5.2L2 15.6H12V5.2H2.003ZM6 3.46667H14V12.1333H16V1.73333H6V3.46667Z",
    fill: "#6638A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyClipboard);
export default __webpack_public_path__ + "static/media/copy-clipboard.899224457c2cab3d55213490c401181a.svg";
export { ForwardRef as ReactComponent };